import { get2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { RestaurantTable } from "@/shared/utils/interfaces";
import { useQuery } from "@tanstack/react-query";

const useRestaurantAllTables = () => {
  const branch = useBranchId();
  return useQuery<RestaurantTable[]>({
    queryKey: ["restaurantAllTables", branch],
    queryFn: () => get2(`/internal/secure/pos/v1/tables/all/${branch}`),
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  });
};

export default useRestaurantAllTables;
